import { string } from '@iwentsourcing/core/typing/string.js';
import { TypeOfEvent } from '@iwentsourcing/core/typing/type-of.js';
import { declareEvent } from '@iwentsourcing/core/storage/declare-event.js';

export const AcceptInviteEvent = declareEvent('accept-invite', {
  groupId: string(),
  groupMemberId: string(),
});
export type AcceptInviteEvent = TypeOfEvent<typeof AcceptInviteEvent>;
